import React, {useState, useEffect} from 'react';
import {QRCodeCanvas} from 'qrcode.react';
import './MemberCode.css';
import brandHeaderImage from './assets/images/brand-header.png'; // 导入品牌标题图片
import vipIconImage from './assets/images/vip-icon.png'; // 导入 VIP 图标
import wechatPayImage from './assets/images/wechat-pay.png'; // 导入微信支付图标
import reloadIconImage from './assets/images/reload-icon.png'; // 导入重新加载图标
import dividerImage from './assets/images/divider.png'; // 导入分隔线图片

function MemberCode() {
  const memberId = '1909415195213058049'; // 从图片中获取的会员 ID
  const [timestamp, setTimestamp] = useState(Date.now());

  const updateTimestamp = () => {
    const newTimestamp = Date.now();
    setTimestamp(newTimestamp);
    console.log(`二维码更新时间戳: ${newTimestamp}`);
  };

  // 自动每100秒刷新二维码
  useEffect(() => {
    const timer = setInterval(() => {
      updateTimestamp();
    }, 100000); // 100秒 = 100000毫秒
    return () => clearInterval(timer);
  }, []);

  const reloadCode = () => {
    console.log('点击重新加载');
    updateTimestamp();
    // 在实际应用中，这里可能还需要调用 API
  };

  const goToWeChatPay = () => {
    console.log('跳转到微信支付');
    // 在实际应用中，这里会处理跳转逻辑
    window.location.href = 'weixin://widget/pay'; // 添加跳转逻辑
  };

  const qrCodeValue = `${memberId}_${timestamp}`;

  return (
    <div className="member-code-container">
      {/* 顶部导航栏 */}
      <div className="header">
        <div className="header-left">
          <span>&lt;</span> {/* 返回图标 */}
          <span>&#x1F3E0;</span> {/* Home 图标 */}
        </div>
        <div className="header-title">会员码</div>
        <div className="header-right">
          <span>...</span> {/* 更多选项图标 */}
          <span>&#x25CE;</span> {/* 目标图标 */}
        </div>
      </div>

      {/* 用户信息 */}
      <div className="user-info">
        <div className="user-name-line">
          <span className="user-name">华仔先生呀呀呀</span>
          <span className="super-member-badge">
            <img src={vipIconImage} alt="超级荟员" style={{height: '23px', width: 'auto'}}/>
          </span>
        </div>
        <div className="user-desc-info">
          <div className="store-info">
            荟品仓：品牌特卖 荟选好物
          </div>
          <div className="expire-info">
            超级荟员 2026-04-14到期
          </div>
        </div>
      </div>

      {/* 二维码卡片 */}
      <div className="code-card">
        <div>
          <div className="brand-header">
            <img src={brandHeaderImage} alt="Himaxx | 荟品仓"/>
          </div>
          <div className="member-id">{memberId}</div>
          <div className="qr-code-wrapper" onClick={updateTimestamp} style={{cursor: 'pointer'}}>
            <QRCodeCanvas
              value={qrCodeValue}
              size={180}
              level={"H"}
              includeMargin={false}
            />
          </div>
          <div className="reload-section" onClick={reloadCode}>
            <span className="reload-icon">
              <img src={reloadIconImage} alt="" style={{width: '12px', height: 'auto'}}/>
            </span>
            <span>重新加载</span>
          </div>
        </div>

        <div className="divider">
          <img src={dividerImage} alt="---" style={{width: '100%', height: 'auto'}}/>
        </div>

        <div onClick={goToWeChatPay}>
          <div className="wechat-pay-icon">
            <img src={wechatPayImage} alt="" style={{width: '28px', height: 'auto'}}/>
          </div>
          <div className="wechat-pay-button">
            <span>去使用微信支付 &gt;</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MemberCode; 